import React from "react";
import { Link } from "react-router-dom";
import "./PackageSection.css";

const eventPackages = [
  {
    id: "denver-team-adventure",
    city: "Denver, Colorado",
    badge: "Starting Package Plan",
    title: "Denver Team Adventure Day",
    summary:
      "A half-day team experience combining an interactive group activity, a reserved meal, and planning support.",
    includes: [
      "Private team activity",
      "Reserved lunch or dinner",
      "Vendor communication",
      "Custom event timeline",
    ],
    groupSize: "12–30 people",
    duration: "4–5 hours",
    price: "Estimated from $125/person",
    buttonText: "Customize This Package",
    visual: "denver",
  },
  {
    id: "casper-team-connection",
    city: "Casper, Wyoming",
    badge: "Customizable Package",
    title: "Casper Team Connection Package",
    summary:
      "A flexible company event built around your team’s goals, schedule, budget, and preferred atmosphere.",
    includes: [
      "Curated activity options",
      "Meal or refreshment planning",
      "Vendor comparisons",
      "Coordination support",
    ],
    groupSize: "10–50 people",
    duration: "Custom duration",
    price: "Custom pricing",
    buttonText: "Build My Package",
    visual: "casper",
  },
];

const PackageSection = () => {
  return (
    <section id="packages" className="oo-packages">
      <div className="oo-packages-inner">
        <div className="oo-packages-heading">
          <div>
            <p className="eyebrow">Complete Event Packages</p>

            <h2>More than an idea. A custom plan built for your team.</h2>

            <p className="oo-packages-intro">
              Choose a starting point, and we&apos;ll tailor the experience and
              coordinate the details for your team.
            </p>
          </div>

          <Link
            to="/package-request?packageName=Custom%20Office%20Outing%20Package"
            className="oo-packages-request-link"
          >
            Request a custom package →
          </Link>
        </div>

        <div className="oo-package-grid">
          {eventPackages.map((eventPackage) => {
            const packageRequestUrl =
              `/package-request?packageName=${encodeURIComponent(
                eventPackage.title
              )}&packageLocation=${encodeURIComponent(eventPackage.city)}`;

            return (
              <article className="oo-package-card" key={eventPackage.id}>
                <div
                  className={`oo-package-visual oo-package-visual--${eventPackage.visual}`}
                >
                  <span className="oo-package-badge">
                    {eventPackage.badge}
                  </span>

                  <div className="oo-package-visual-copy">
                    <span>{eventPackage.city}</span>
                    <strong>{eventPackage.title}</strong>
                  </div>
                </div>

                <div className="oo-package-body">
                  <p className="oo-package-summary">
                    {eventPackage.summary}
                  </p>

                  <div className="oo-package-includes">
                    {eventPackage.includes.map((item) => (
                      <span key={item}>
                        <span aria-hidden="true">✓</span>
                        {item}
                      </span>
                    ))}
                  </div>

                  <div className="oo-package-details">
                    <div>
                      <span>{eventPackage.groupSize}</span>
                      <span>{eventPackage.duration}</span>
                    </div>

                    <strong>{eventPackage.price}</strong>
                  </div>

                  <Link
                    to={packageRequestUrl}
                    className="oo-package-button"
                  >
                    {eventPackage.buttonText}
                  </Link>
                </div>
              </article>
            );
          })}
        </div>

        <p className="oo-packages-note">
          These packages are starting concepts and can be customized. Final
          pricing, inclusions, and availability depend on the selected vendors
          and event details.
        </p>
      </div>
    </section>
  );
};

export default PackageSection;
